"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var _queryParamUtils = require("../utils/queryParamUtils");

var _validators = require("pricing-pages-unified-ui/utils/validators");

var termFromQueryParam = (0, _queryParamUtils.getQueryParams)().term;
var initialState = (0, _validators.validateTermOrGetDefault)(termFromQueryParam);

var ActiveTerm = function ActiveTerm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.ACTIVE_TERM_UPDATED:
      return payload;

    default:
      return state;
  }
};

var _default = ActiveTerm;
exports.default = _default;
module.exports = exports.default;